// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".upgrade-bar{margin-bottom:5px}.upgrade-bar .upgrade-block{margin-right:4px}\n", "",{"version":3,"sources":["webpack://./src/styles/upgrade-bar.scss"],"names":[],"mappings":"AAAA,aAIE,iBAAkB,CAJpB,4BAEI,gBAAiB","sourcesContent":[".upgrade-bar {\n  .upgrade-block {\n    margin-right: 4px;\n  }\n  margin-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
